// @ts-nocheck
import React from "react";
import { Link } from "react-router-dom";
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ReciboIcono } from "./IconosMenu";

const itemSx = {
    mx: 0.5,
    borderRadius: 2,
    color: '#2d2d2d',
    transition: 'color 0.2s, background-color 0.2s',
    '&:hover': {
        backgroundColor: 'rgba(183, 18, 52, 0.06)',
        color: '#B71234',
    },
    '& .MuiListItemIcon-root': {
        color: 'inherit',
        minWidth: 44,
    },
};

export default function ReciboItem({ onClick }) {
    return (
        <Link onClick={onClick} to="/recibos" style={{ textDecoration: 'none' }}>
            <ListItem button key="recibos" sx={itemSx}>
                <ListItemIcon>
                    <ReciboIcono />
                </ListItemIcon>
                <ListItemText primary="Recibos" />
            </ListItem>
        </Link>
    );
}
